export const chartDays = [
    {
      label: "24 Hours",
      value: 1,
    },
    {
      label: "30 Days",
      value: 30,
    },
    {
      label: "3 Months",
      value: 90,
    },
    {
      label: "1 Year",
      value: 365,
    },
    {
      label: "5 Year",
      value: 1840,
    },
    {
      label: "10 Year",
      value: 3650,
    },
  ];